export default {
  smallTimeout: 50,
  bigTimeout: 1000
}
